import React, { createElement } from "react";
import AdComponent from '@ifeng-fe/ui_pc_ad';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface Ad_Props {
    nodeId?: string
    adChip: TYPE_Chip
}

const Ad: React.FC<Ad_Props> = (props) => {
    const { nodeId, adChip } = props

    const adChipData = useChip(adChip)
    const chipComponentData = formatChip(adChip)

    return (
        <Chip {...chipComponentData}>
            {
                adChip && Object.keys(adChipData).length > 0
                ?
                    <AdComponent
                        id={nodeId}
                        key={adChipData?.data?.aids[0]?.ap}
                        content={{
                            desc: {
                                name: adChip.id,
                                id: adChip.id,
                                type: 'ad',
                                title: adChip.title
                            },
                            ...adChipData
                        }}
                    />
                :
                    <div  style={{ position: 'relative', height: '50px' }}>
                        <Mask visible={true} zIndex={3}>
                            暂无广告
                        </Mask>
                    </div>
            }
        </Chip>
    )
}

export default Ad
